import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import { handleAsyncAction } from "../../../../Setup";

export const setConfig = (payload) => ({
    type: CONST.SET_CONFIG,
    payload,
});

export const setSelectedArchive = (payload) => ({
    type: CONST.SET_SELECTED_ITEM,
    payload: payload
});

/*****************************************************
 * Fetch Archive Roster
 ****************************************************/
export const fetchArchiveRosterSuccess = (payload) => ({
    type: CONST.FETCH_ITEM_SUCCESS,
    payload: payload
});

export const fetchArchiveRosterFailed = (payload) => ({
    type: CONST.FETCH_ITEM_FAILED,
    payload: payload
});

export const fetchArchiveRoster = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`roster/rosters/${filters['id']}`, {params: filters}),
        [fetchArchiveRosterSuccess],
        [fetchArchiveRosterFailed]
    );
};

/*****************************************************
 * Fetch Archive Rosters
 ****************************************************/
export const fetchArchiveRostersSuccess = (payload) => ({
    type: CONST.FETCH_ITEMS_SUCCESS,
    payload: payload
});

export const fetchArchiveRostersFailed = (payload) => ({
    type: CONST.FETCH_ITEMS_FAILED,
    payload: payload
});

export const fetchArchiveRosters = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/documents', { params: filters }),
        [fetchArchiveRostersSuccess],
        [fetchArchiveRostersFailed]
    );
};
